import React, { useState } from 'react';
import { View, Text, Switch, TextInput } from 'react-native';
import styles from '@stylesheet';
import { ValidationType } from '../types/validatorTypes';
import updateStoreHandler from '../utils/updateStoreHandler';
import * as Animatable from 'react-native-animatable';
import DropDownPicker from 'react-native-dropdown-picker';
import ComponentRenderer from './ComponentRenderer';
import defaultValComponents, { ValidationComponentType } from '../utils/defaultValComponents';
import { themeSelector } from '@reduxLocal/selectors/themeSelector';

const BooleanValidation = ({ index, item }: ValidationType) => {
  const initialObject = item || {}; // Ensure item is not null or undefined
  const initialMap = new Map(Object.entries(initialObject));
  const [validationOptions, setValidationOptions] = useState(initialMap);

  const updateMap = (key, value) => {
    setValidationOptions((prevMap) => new Map(prevMap.set(key, value)));
  };

  // Define an array of configuration objects for each component
  const validationComponents: ValidationComponentType[] = [
    ...defaultValComponents,
    { key: 'defaultValue', label: 'Default Value', type: 'switch' },
    { key: 'trueOutput', label: 'True Output', type: 'textInput' },
    { key: 'falseOutput', label: 'False Output', type: 'textInput' },
  ];

  const handleValidationChange = (value, key) => {
    updateMap(key, value);
    const options = { value, type: key };
    updateStoreHandler({ index, option: options });
  };

  const renderComponent = (component) => {
    const { key, label, type, inputMode } = component;
    const [open, setOpen] = useState(false);
    const [textValue, setTextValue] = useState(validationOptions.get(key));

    switch (type) {
      case 'switch':
        return (
          <Switch
            value={validationOptions.get(key)}
            onValueChange={(value) => handleValidationChange(value, key)}
          />
        );
      case 'textInput':
        return (
          <View style={{ flex: 1, marginVertical: 4 }}>
            <Text style={{ flex: 1 }}>{component.label}</Text>
            <TextInput
              placeholder={label}
              style={styles.inputOutline}
              value={textValue}
              onChangeText={(value) => setTextValue(value)}
              onBlur={() => handleValidationChange(textValue, key)}
              inputMode={inputMode}
            />
          </View>
        );
      // Add more cases for additional types
      default:
        return null; // Return null for unsupported types
    }
  };

  const theme = themeSelector();

  return (
    <View style={{
      padding: 16,
      borderRadius: 12,
      backgroundColor: theme ? '#f8fafc' : '#0f172a',
      gap: 12,
    }}>
      {validationComponents.map((component) => (
        <View key={component.key} style={{ width: '100%' }}>
          <ComponentRenderer item={item} component={component} index={index} />
        </View>
      ))}
    </View>
  );
};



export default BooleanValidation;
